import {
  $InternalCoursesState,
  $InternalCourses,
  fetchInternalCourses,
} from "@store/internal-study/courses-store";
import {
  CourseShortDataT,
  CourseLessonsDataT,
} from "@interfaces/internal-study/courses";
import InternalStudyCoursesService from "@services/internal-study-courses-service";
import { CourseTablePropsT } from "@interfaces/internal-study/courses";
import {
  Table,
  TableHead,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
} from "@mui/material";
import { ErrorIndicator, Loader } from "@ui/indicators";
import React, { useEffect } from "react";

import clsx from "clsx";
import style from "@scss/pages/study-center.module.scss";
import tableStyle from "@scss/components/tables/base-table.module.scss";
import { useCompanyId } from "@store/company/company-store";
import useModal from "@modals/modal-hook";
import { useUnit } from "effector-react";
import InternalStudyСoursesTableRow from "./courses_row";

const InternalStudyСoursesTable: React.FC<CourseTablePropsT> = (props) => {
  const { onSyncCourse, onSyncLesson } = props;
  const { isLoading, error, isFetched } = useUnit($InternalCoursesState);
  const internalCourses = useUnit($InternalCourses);
  const companyId = useCompanyId();

  const { open } = useModal();

  const handleRemoveCourse = (course: CourseShortDataT) => {
    open("ConfirmActionModal", {
      btnText: "Удалить",
      modalData: {
        text: `Вы уверены, что хотите удалить курс обучения "${course.title}"?`,
      },
      onConfirm: () => {
        InternalStudyCoursesService.delete(course.id, (err, res) => {
          if (err || !res) {
            return Error("При удалении курса обучения произошла ошибка");
          }
          if (res.data) {
            fetchInternalCourses();
          }
        });
      },
    });
  };

  const handleRemoveLesson = (lesson: CourseLessonsDataT) => {
    open("ConfirmActionModal", {
      btnText: "Удалить",
      modalData: {
        text: `Вы уверены, что хотите удалить урок обучения "${lesson.title}"?`,
      },
      onConfirm: () => {
        InternalStudyCoursesService.deleteLesson(lesson.id, (err, res) => {
          if (err || !res) {
            return Error("При удалении урока обучения произошла ошибка");
          }
          if (res.data) {
            fetchInternalCourses();
          }
        });
      },
    });
  };

  useEffect(() => {
    if (!isFetched && companyId !== null) {
      fetchInternalCourses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableContainer
      className={clsx(
        tableStyle.base_table_container,
        style.courses_table,
        style.no_border_top
      )}
      sx={{ position: "relative", overflow: "unset" }}
    >
      {isLoading ? (
        <Loader />
      ) : error ? (
        <ErrorIndicator />
      ) : (
        <Table className={clsx(tableStyle.base_table)}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              {internalCourses.filter((e) => e.thumbnail !== null).length >
                0 && <TableCell>Обложка</TableCell>}
              <TableCell>Название курса</TableCell>
              <TableCell>Кол-во вложенных курсов</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {internalCourses.length ? (
              internalCourses.map((course) => (
                <InternalStudyСoursesTableRow
                  course={course}
                  thumbnail={
                    internalCourses.filter((e) => e.thumbnail !== null).length >
                    0
                  }
                  onSyncCourse={onSyncCourse}
                  onSyncLesson={onSyncLesson}
                  onRemoveCourse={handleRemoveCourse}
                  onRemoveLesson={handleRemoveLesson}
                />
              ))
            ) : (
              <tr>
                <td>
                  <p
                    style={{
                      textAlign: "center",
                      width: "100%",
                      margin: "24px 0px",
                    }}
                  >
                    Курсы не добавлены
                  </p>
                </td>
              </tr>
            )}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default InternalStudyСoursesTable;
